module.exports = __webpack_public_path__ + "media/assets/images/icons/attachments-icon2-5e7e5154e1bdde3e63348c2b1c66039b.svg";